export const API_ERROR = 'API_ERROR'
export const REMOVE_BG_IMG_URL = 'REMOVE_BG_IMG_URL'
export const REMOVE_LOGO_URL = 'REMOVE_LOGO_URL'
export const SET_BG_IMG_URL = 'SET_BG_IMG_URL'
export const SET_LOGO_URL = 'SET_LOGO_URL'
export const SET_STARTUP_DATA = 'SET_STARTUP_DATA'
export const START_FETCH = 'START_FETCH'
export const START_SAVE = 'START_SAVE'
export const STOP_FETCH = 'STOP_FETCH'
export const STOP_SAVE = 'STOP_SAVE'
